import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoTag",style:({ backgroundColor: _vm.tagBackground })},[_c('div',{staticClass:"infoTagIcon",style:({ backgroundColor: _vm.iconBackgroundColor })},[_c(VIcon,{attrs:{"color":_vm.iconColor}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1),_c('span',{staticClass:"infoTagText"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }